<ng-template #header>
  <div nz-col nzFlex="auto">
    <form
      nz-form
      [nzLayout]="'inline'"
      [formGroup]="searchForm"
      (ngSubmit)="search()"
    >
      <beautyapp-input
        formControlName="search"
        placeholder="{{'search.searchWord' | translate }}"
        prefixIcon="search"
      ></beautyapp-input>
      <beautyapp-select
        placeholder="{{'search.category' | translate }}"
        [data]="categories()"
        displayMember="name"
        valueMember="id"
        formControlName="productCategoryId"
      >
      </beautyapp-select>
      <beautyapp-select
        placeholder="{{'search.distributor' | translate }}"
        [data]="distributors()"
        displayMember="name"
        valueMember="id"
        formControlName="distributorId"
      >
      </beautyapp-select>
      <nz-space>
        <button
          *nzSpaceItem
          nz-button
          nzType="primary"
          nzSize="small"
          nzShape="circle"
          [disabled]="!searchForm.valid"
        >
          <i nz-icon nzType="search" nzTheme="outline"></i>
        </button>
        <button
          *nzSpaceItem
          nz-button
          nzSize="small"
          nzShape="circle"
          type="button"
          (click)="clearSearch()"
        >
          <i nz-icon nzType="close" nzTheme="outline"></i>
        </button>
      </nz-space>
    </form>
  </div>
</ng-template>

<nz-table
  [nzTitle]="header"
  nzShowSizeChanger
  [nzData]="services()"
  [nzFrontPagination]="false"
  [nzLoading]="loading()"
  [nzTotal]="total()"
  [nzPageSize]="pageSize()"
  [nzPageIndex]="page()"
  (nzQueryParams)="paginatorChange($event)"
  [nzPageSizeOptions]="[5, 10, 20, 50, 100]"
  nzSize="small"
>
  <thead>
  <tr>
    <th nzWidth="150px" nzColumnKey="barcode" [nzSortFn]="true">
      {{'warehouse.products.column.barcode' | translate}}
    </th>
    <th nzWidth="150px" nzColumnKey="barcode" [nzSortFn]="true">
      {{'warehouse.products.column.productCode' | translate}}
    </th>
    <th nzWidth="300px" >
      {{'warehouse.products.column.title' | translate}}
    </th>
    <th nzWidth="150px">
      {{'warehouse.products.column.quantity' | translate}}
    </th>
    <th
      nzWidth="150px"
    >
      {{'warehouse.products.column.salePrice' | translate}}
    </th>
    <th nzRight nzWidth="80px" class="transaction-delete-td"></th>
  </tr>
  </thead>
  <tbody>
    @for (row of services(); track $index) {
      <tr>
        <td>{{ row?.barcode }}</td>
        <td>{{ row?.productCode }}</td>
        <td>
          <div class="text-lg font-bold">{{ row?.name }}</div>
          <div class="flex gap-1">
            <div class="text-md">კატეგორია</div>
            <div class="text-md text-gray-400">{{ row?.productCategory?.name }}</div>
          </div>
          <div class="flex gap-1">
            <div class="text-md">
              მომწოდებელი
            </div>
            <div class="text-md text-gray-400">{{ row?.distributor?.name }}</div>
          </div>

        </td>
        <td>
          <div>{{ row?.quantity }} ცალი</div>
          <div>{{ row?.grSum }} გრამი</div>
        </td>
        <td>{{ row?.salePricePerItem }}</td>
        <td nzRight>
          <button
            (click)="productSelected.emit(row)"
            nz-button
            nzType="primary"
            nzShape="circle"
          >
            <nz-icon nzType="right" nzTheme="outline" />
          </button>
        </td>
      </tr>
    }
  </tbody>
</nz-table>
